import { IComponentOptions } from 'angular';
import {
    FONT_POSTURE_OPTIONS,
    FONT_WEIGHT_OPTIONS,
    FONT_WIDTH_OPTIONS,
    FontPosture,
    FontStyleService,
    FontWeight,
    FontWidth,
    IFontFamilyModel,
    IFontStyleModel,
    Option,
} from '../../../tn.common';
import template from './style-page-sidebar.html';

export class FontStyleSidebarController {
    // bindings
    style?: IFontStyleModel;
    family?: IFontFamilyModel;

    // locals
    postures: Option<FontPosture>[] = [];
    styles: IFontStyleModel[] = [];
    weights: Option<FontWeight>[] = [];
    widths: Option<FontWidth>[] = [];

    static $inject = ['FontStyleService'];
    constructor(protected styleService: FontStyleService) {}

    $onInit() {
        this.postures = FONT_POSTURE_OPTIONS.filter((posture) =>
            this.family?.posture.includes(posture.value)
        );
        this.weights = FONT_WEIGHT_OPTIONS.filter((weight) =>
            this.family?.weight.includes(weight.value)
        );
        this.widths = FONT_WIDTH_OPTIONS.filter((width) =>
            this.family?.width.includes(width.value)
        );
    }

    getStyles() {
        const styleIds = this.family?.style;
        if (!styleIds) {
            return Promise.resolve([]);
        }
        return this.styleService
            .list({
                id: styleIds,
                page_size: 10000,
            })
            .then((styles) => {
                this.styles = styles.results;
                return this.styles;
            });
    }

    getStyle(weight?: FontWeight, width?: FontWidth, posture?: FontPosture) {
        const _weight = weight || this.style?.weight;
        const _width = width || this.style?.width;
        const _posture = posture || this.style?.posture;
        return this.styles.filter((style) => {
            return (
                style.weight === _weight &&
                style.width === _width &&
                style.posture === _posture
            );
        })[0];
    }

    getStyleForWeight(weight: FontWeight) {
        return this.getStyle(weight, undefined, undefined);
    }

    getStyleForWidth(width: FontWidth) {
        return this.getStyle(undefined, width, undefined);
    }

    getStyleForPosture(posture: FontPosture) {
        return this.getStyle(undefined, undefined, posture);
    }
}

export const StylePageSidebarComponent: IComponentOptions = {
    controller: FontStyleSidebarController,
    controllerAs: 'vm',
    template,
    bindings: {
        family: '<',
        style: '<',
    },
};
